export default __webpack_public_path__ + "a1e0569.png";